import { APP_ICON_SRC } from '../lib/brand'

export function Logo({ compact = false }: { compact?: boolean }) {
  return <div className={`brand-lockup${compact ? ' compact' : ''}`}>
    <div className="brand-mark" aria-hidden="true"><img src={APP_ICON_SRC} alt="" /></div>
    <div><strong>诗序</strong>{compact ? null : <small>让诗词，照进生活。</small>}</div>
  </div>
}
